import { Registry } from './registry.model';

export class Keyword extends Registry {
}
